import { injectReducer } from 'store/reducers.js'
import { authRoute } from 'helpers/routes'
import { userId as currentUserId } from 'helpers/auth'
import { injectExternalList, injectExternalReducer } from 'helpers/actions'

export const UsersRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'users',
  authentication: 'admin',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/UsersContainer').default

      const actions = require('./modules/users').actions
      const reducer = require('./modules/users').default

      injectReducer(store, { key: 'users', reducer })

      store.dispatch(actions.get())

      cb(null, Container)
    }, 'users')
  }
})

export const AccountRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'account',
  authentication: true,
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/AccountContainer').default

      const actions = require('./modules/user').actions
      const reducer = require('./modules/user').default
      injectExternalReducer(store, 'auth')

      injectReducer(store, { key: 'user', reducer })

      store.dispatch(actions.get(currentUserId())).then(() => { // WARNING: This may not be valid.
        return cb(null, Container)
      })
    }, 'users')
  }
})

export const NewUserRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'users/new',
  authentication: 'admin',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/NewUserContainer').default

      const reducer = require('./modules/user').default

      injectReducer(store, { key: 'user', reducer })
      injectExternalList(store, 'customers')

      cb(null, Container)
    }, 'users')
  }
})

export const EditUserRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'users/:id/edit',
  authentication: 'admin',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/EditUserContainer').default

      const actions = require('./modules/user').actions
      const reducer = require('./modules/user').default

      injectReducer(store, { key: 'user', reducer })

      store.dispatch(actions.get(nextState.params.id))

      injectExternalList(store, 'customers')

      cb(null, Container)
    }, 'users')
  }
})

export default function (store) {
  return [
    AccountRoute(store),
    NewUserRoute(store),
    EditUserRoute(store),
    UsersRoute(store)
  ]
}



// WEBPACK FOOTER //
// ./src/routes/Users/index.js